import { useStore } from "zustand";
import { useShallow } from "zustand/react/shallow";

import { stampcardStore } from "./store";
import type { StampcardState } from "./store.types";
import { getStampcardState } from "./getters";

function useStampcardState(): StampcardState {
  return useStore(stampcardStore, useShallow(getStampcardState));
}

export { useStampcardState };
